import React from 'react';
import {
    FlexDiv,
    SpaceBetweenDiv,
    Heading3,
    ThemedButton,
    TextDefault,
} from './ui';
import SaveIcon from '@mui/icons-material/Save';
import PreviewIcon from '@mui/icons-material/Preview';
import CloseIcon from '@mui/icons-material/Close';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import SettingsIcon from '@mui/icons-material/Settings';
import DataObjectIcon from '@mui/icons-material/DataObject';

function EditorToolbar({
    question,
    isDirty,
    canSaveInPlace,
    onSave,
    onSaveAs,
    onPreview,
    onShowJson,
    onQuestionSettings,
    onCancel,
}) {
    const isNew = !question?.id;
    const showSaveAs = !isNew && !canSaveInPlace;
    const saveDisabled = !isDirty || (!canSaveInPlace && !isNew);
    const saveAsDisabled = !isDirty || isNew;

    return (
        <div className="editor-toolbar">
            <SpaceBetweenDiv alignCenter padding={16}>
                <FlexDiv alignCenter gap={16}>
                    <Heading3>Question Editor</Heading3>
                    {isDirty && (
                        <TextDefault color="warning">
                            • Unsaved changes
                        </TextDefault>
                    )}
                </FlexDiv>

                <FlexDiv alignCenter gap={12}>
                    {onQuestionSettings ? (
                        <ThemedButton
                            mode="secondary"
                            startIcon={<SettingsIcon />}
                            onClick={onQuestionSettings}
                            text="Question settings"
                        />
                    ) : null}
                    {onPreview ? (
                        <ThemedButton
                            mode="secondary"
                            startIcon={<PreviewIcon />}
                            onClick={onPreview}
                            text="Preview"
                        />
                    ) : null}
                    {onShowJson ? (
                        <ThemedButton
                            mode="secondary"
                            startIcon={<DataObjectIcon />}
                            onClick={onShowJson}
                            text="Show JSON"
                        />
                    ) : null}

                    {showSaveAs ? (
                        <ThemedButton
                            mode="primary"
                            startIcon={<FileCopyIcon />}
                            onClick={onSaveAs}
                            disabled={saveAsDisabled}
                            text="Save as copy"
                        />
                    ) : (
                        <ThemedButton
                            mode="primary"
                            startIcon={<SaveIcon />}
                            onClick={onSave}
                            disabled={saveDisabled}
                            text={isNew ? 'Create question' : 'Save question'}
                        />
                    )}

                    {!showSaveAs && !isNew && onSaveAs && (
                        <ThemedButton
                            mode="secondary"
                            startIcon={<FileCopyIcon />}
                            onClick={onSaveAs}
                            disabled={saveAsDisabled}
                            text="Save as copy"
                        />
                    )}

                    <ThemedButton
                        mode="secondary"
                        startIcon={<CloseIcon />}
                        onClick={onCancel}
                        text="Cancel"
                    />
                </FlexDiv>
            </SpaceBetweenDiv>
        </div>
    );
}

export default EditorToolbar;
